/* eslint-disable global-require */
/* eslint-disable func-names */
import EDC from './globals';

/**
 *
 */
EDC.Preloaders.AnswerMark = function (scene) {
  this.scene = scene;
  this.scene.load.image('answer-result-correct-mark', require('@/components/games/shared/assets/check-mark.png'));
  this.scene.load.image('answer-result-wrong-mark', require('@/components/games/shared/assets/cross-mark.png'));
};
/**
 *
 */
EDC.Animations.AnswerMark = function (scene, parentContainer) {
  this.scene = scene;
  this.parent = parentContainer;
  this.markScale = 1;
  this.correctMark = this.scene.add.sprite(0, 0, 'answer-result-correct-mark');
  this.correctMark.setScale(0, 0);
  this.wrongMark = this.scene.add.sprite(0, 0, 'answer-result-wrong-mark');
  this.wrongMark.setScale(0, 0);
  this.parent.add([this.correctMark, this.wrongMark]);
  return this;
};
/**
 *
 */
EDC.Animations.AnswerMark.prototype.setScale = function (newScale) {
  this.markScale = newScale;
  return this;
};
/**
 *
 */
EDC.Animations.AnswerMark.prototype.reset = function () {
  this.correctMark.setScale(0, 0);
  this.wrongMark.setScale(0, 0);
};
/**
 *
 */
EDC.Animations.AnswerMark.prototype.showMark = function (isCorrect, completeCallback) {
  this.scene.tweens.add({
    targets: isCorrect ? this.correctMark : this.wrongMark,
    scaleX: this.markScale,
    scaleY: this.markScale,
    duration: 800,
    ease: 'Bounce.easeOut',
    onComplete: completeCallback,
  });
  return this;
};

const exportPreloader = EDC.Preloaders.AnswerMark;
const exportMark = EDC.Animations.AnswerMark;

export { exportPreloader as AnswerMarkPreloader, exportMark as AnswerMark };
